"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBuiltInProperty = void 0;
var tslib_1 = require("tslib");
var isFunction_1 = tslib_1.__importDefault(require("lodash/isFunction"));
// Built-in properties of the class.
var builtIn = ['name', 'prototype', 'length'];
/**
 * Determine whether is built-in property of the class or prototype.
 *
 * @param target Class (property).
 * @param property Property name.
 * @return True in case property is built-in; false otherwise.
 */
function isBuiltInProperty(target, property) {
    return isFunction_1.default(target) ? builtIn.indexOf(property) >= 0 : property === 'constructor';
}
exports.isBuiltInProperty = isBuiltInProperty;
//# sourceMappingURL=isBuiltInProperty.js.map